import {createAction} from '@reduxjs/toolkit'

import {CouponView} from './interfaces'

/** 스토어 쿠폰 선택 */
export const selectStoreCoupon = createAction<{
    merchantNo: number
    couponId: Maybe<string>
    /** 선택 해지 인지 확인 */
    isRemove: boolean
}>('orderSheetCoupon/selectStoreCoupon')

/** 스토어 선택된 쿠폰 업데이트 */
export const updateSelectedStoreCoupons = createAction<{[MerchantNo: number]: Maybe<CouponView>}>(
    'orderSheetCoupon/updateSelectedStoreCoupons',
)

/** useAllCoupon 필드 업데이트 */
export const updateUseAllCoupon = createAction<boolean>('orderSheetCoupon/updateUseAllCoupon')

/** useAllCoupon toggle */
export const toggleUseAllCoupon = createAction<void>('orderSheetCoupon/toggleUseAllCoupon')
